import { BsTools, BsBell } from "react-icons/bs";
import { FaList, FaChartLine } from "react-icons/fa";

/**
 * Service Provider Sidebar Menu Configuration
 * Defines menu structure for service provider role users
 */
export const getServiceProviderMenus = (counts = {}) => {
  return [
    [
      "Dashboard",
      [
        {
          name: "Dashboard",
          route: "/service-provider/dashboard",
          icon: <FaChartLine />,
          permission: "view_notification",
        },
        {
          name: "Notifications",
          route: "/service-provider/notifications",
          icon: <BsBell />,
          permission: "view_notification",
          count: counts?.notification_count,
        },
      ],
    ],
    [
      "Service Management",
      [
        {
          name: "My Services",
          route: "/service-provider/services",
          icon: <BsTools />,
          permission: "view_service",
          count: counts?.service_count,
        },
        {
          name: "Service Requests",
          route: "/service-provider/requests",
          icon: <FaList />,
          permission: "view_request_services",
          count: counts?.request_count,
        },
      ],
    ],
  ];
};

/**
 * Get menu items based on user permissions
 * @param {string[]} permissions - User permissions array
 * @param {Object} counts - Count data for menu badges
 * @returns {Array} Filtered menu structure
 */
export const getFilteredServiceProviderMenus = (permissions = [], counts = {}) => {
  const menus = getServiceProviderMenus(counts);
  
  if (!permissions || permissions.length === 0) {
    return [];
  }

  let filteredMenus = [];
  
  menus.forEach((menu) => {
    const [sectionName, menuItems] = menu;
    const filtered = menuItems.filter((item) =>
      permissions.includes(item.permission)
    );
    
    if (filtered.length > 0) {
      filteredMenus.push([sectionName, filtered]);
    }
  });

  return filteredMenus;
};

export default getServiceProviderMenus;
